export default "16:35 UTC<br />\nSS 17:03 UTC   ECT 17:40 UTC";